import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-istituzioni',
  templateUrl: './istituzioni.component.html',
  styleUrls: ['./istituzioni.component.css']
})
export class IstituzioniComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
